'use es6';

import { Record } from 'immutable';
const MembershipCountsRecord = new Record({
  nonMarketableContacts: null,
  quarantinedContacts: null,
  sentContacts: null
});
export default MembershipCountsRecord;